import React from 'react';

export default function EmptyEntryTab(): JSX.Element {
  return <div className="buffer-tab-emptyEntryText">The entry has no protocols.</div>;
}
